module.exports = __webpack_public_path__ + "static/img/dailyweekly.7819c60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dailyweekly.png
// module id = 3wbk
// module chunks = 1